//
// Path Social free profile viewer — anonymous WordPress admin-ajax, browser-fingerprint path.
//   POST https://pathsocial.com/wp-admin/admin-ajax.php   action=get_user_info_by_username&username=<u>
// Behind a Cloudflare challenge for non-browser clients (2026-10-31 bench): the router treats a
// challenge page as a failure and its breaker parks the lane until a probe passes.
//

import type { Provider } from '../../router/registry';
import { browserHeaders, toIgProfile } from '../../router/shapes';

const ORIGIN = 'https://pathsocial.com';

export const PathSocial: Provider = {
	id: 'pathsocial',
	platform: 'instagram',
	capabilities: ['profile'],
	family: 'own',
	transport: 'browser',
	requiresToken: false,
	seedLatencyMs: 900,
	// OFF by default: Cloudflare answers 403 from production egress. Still registered;
	// SOCIAL_PROV_PATHSOCIAL_ENABLED=true turns it on.
	defaultEnabled: false,
	request: (req) => ({
		url: `${ORIGIN}/wp-admin/admin-ajax.php`,
		init: {
			method: 'POST',
			headers: browserHeaders({
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				Origin: ORIGIN,
				Referer: `${ORIGIN}/free-tools/instagram-profile-viewer/`,
				'X-Requested-With': 'XMLHttpRequest',
				'Sec-Fetch-Site': 'same-origin',
				'Sec-Fetch-Mode': 'cors',
				'Sec-Fetch-Dest': 'empty',
			}),
			body: new URLSearchParams({ action: 'get_user_info_by_username', username: req.query }).toString(),
		},
	}),
	parser: (body) => {
		if (typeof body === 'string') throw new Error('non-JSON body (challenge page?)');
		const b: any = body;
		// admin-ajax convention: { success: bool, data: ... }. Anonymous and unverified, so a negative answer is
		// a failure here, never an authoritative "not found" (only instagram.com / StarAPI may say that).
		if (b?.success === false) throw new Error(`pathsocial: ${String(b?.data?.message ?? b?.data ?? 'no data')}`);
		try {
			return toIgProfile(b?.data ?? b);
		} catch (error: any) {
			throw new Error(`pathsocial: ${error?.message || 'unparseable profile'}`);
		}
	},
};

export default PathSocial;
